import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "@mui/material/Alert";
import axios from "axios";
import Cookies from "js-cookie";
import * as React from "react";
import { useState } from "react";
import { Navigate, NavLink } from "react-router-dom";
import { FlexBox } from "./FlexBox";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "calc(100% - 32px)",
    sm: 440,
  },
  maxWidth: 440,
  boxSizing: "border-box",
  bgcolor: "#FFFFFF",
  border: "1px solid #E3ECF5",
  borderRadius: "22px",
  boxShadow: "0 24px 70px rgba(21,58,91,.22)",
  textAlign: "center",
  fontFamily: "Assistant",
  p: { xs: 2.5, sm: 4 },
  maxHeight: "calc(100vh - 32px)",
  overflowY: "auto",
  outline: "none",
};
export default function AskModal({
  open,
  id,
  setOpen2,
  handleOpen,
  handleClose,
  result,
  changeStep,
  mes,
}) {
  const [doubleCheck, setDoubleCheck] = useState(false);
  const [navigate, setNavigate] = useState(false);
  const [payment, setPayment] = useState(false);
  const [stage, setStage] = useState("confirm");
  const [advanceIntent, setAdvanceIntent] = useState("");
  const [declarationAccepted, setDeclarationAccepted] = useState(false);
  const [formError, setFormError] = useState("");
  const updateBidAccept = () => {
    handleClose();
    setOpen2(true);
    axios
      .put(
        `${process.env.React_APP_BACKEND_URL}/api/updateresult?id=${id}`,
        { bidderaccept: "Yes", safety_acknowledged: true },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      )
      .then((res) => {
        setOpen2(false);
        changeStep(1);
      })
      .catch((err) => console.log(err));
  };
  const handleOfferReject = () => {
    handleClose();
    setOpen2(true);
    axios
      .put(
        `${process.env.React_APP_BACKEND_URL}/api/updateresult?id=${id}`,
        { bidderaccept: "no", major: 3 },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      )
      .then((res) => {
        //setOpen2(false);
        window.location.reload(true);
        //changeStep(1);
      })
      .catch((err) => console.log(err));
  };
  const goToPayment = () => {
    let month = parseInt(new Date().getMonth()) + 1;
    // if (Cookies.get("subscription").toString() === "Yes") {
    //   handleClose();
    //   changeStep(3);
    // } else
    if (result.paymenttype === "free") {
      axios
        .put(
          `${process.env.React_APP_BACKEND_URL}/api/updateresult?id=${id}`,
          {
            proaccept: "Yes",
            payment: "Yes",
            professional_declaration: {
              advance_intent: advanceIntent,
              declaration_accepted: declarationAccepted,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        )
        .then((res) => {
          handleClose();

          changeStep(3);
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .put(
          `${process.env.React_APP_BACKEND_URL}/api/updateresult?id=${id}`,
          {
            professional_declaration: {
              advance_intent: advanceIntent,
              declaration_accepted: declarationAccepted,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        )
        .then(() => setPayment(true))
        .catch((err) => {
          console.log(err);
          setFormError("לא הצלחנו לשמור את ההצהרה. נסה שוב.");
        });
    }
  };

  const submitProfessionalDeclaration = () => {
    if (!advanceIntent) {
      setFormError("יש לבחור תשובה בנוגע לתשלום לפני תחילת העבודה.");
      return;
    }
    if (!declarationAccepted) {
      setFormError("יש לקרוא ולאשר את הצהרת ההתנהלות.");
      return;
    }
    setFormError("");
    goToPayment();
  };
  const handleBidderReject = () => {
    handleClose();
    setOpen2(true);
    axios
      .put(
        `${process.env.React_APP_BACKEND_URL}/api/updateresult?id=${id}`,
        { proaccept: "no", major: 3 },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      )
      .then((res) => {
        setNavigate(true);
        window.location.reload(true);
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ fontFamily: "Assistant" }}>
          {payment && <Navigate to={`/payment/${id}`}></Navigate>}
          {navigate && <Navigate to="/home"></Navigate>}
          {!doubleCheck && stage === "confirm" && (
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                sx={{
                  mb: 2.5,
                  fontFamily: "Assistant",
                  fontWeight: 800,
                  color: "#173B5C",
                  lineHeight: 1.55,
                  fontSize: { xs: "1.05rem", sm: "1.2rem" },
                }}
                variant="h6"
                component="h2"
              >
                {mes === "Offer Accept"
                  ? `ההצעה הזוכה היא ₪${result.bidAmount}. תרצה לאשר את ההצעה ולהתקדם?
                  `
                  : `הצעת המחיר שלך היא על סך ₪​${result.bidAmount}. תרצה לאשר את ההצעה ולהתקדם?`}
              </Typography>
              <FlexBox
                sx={{
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "stretch",
                  justifyContent: "center",
                  gap: 1.2,
                  fontFamily: "Assistant",
                }}
              >
                <Button
                  variant="contained"
                  onClick={
                    mes === "Offer Accept"
                      ? () => setStage("customer-safety")
                      : () => setStage("professional-declaration")
                  }
                  sx={{
                    minWidth: 110,
                    px: 3,
                    py: 1.05,
                    borderRadius: "12px",
                    fontFamily: "Assistant",
                    fontWeight: 800,
                    textTransform: "none",
                    background: "linear-gradient(135deg, #238BEB 0%, #3EA7FF 100%)",
                    boxShadow: "0 8px 18px rgba(35,139,235,.22)",
                  }}
                >
                  {mes === "Offer Accept" ? "כן" : "מאשר"}
                </Button>
                {mes === "Offer Accept" && (
                  <NavLink
                    to={`/viewuserprofile/${result.bidderId}`}
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        minWidth: 130,
                        px: 3,
                        py: 1.05,
                        borderRadius: "12px",
                        fontFamily: "Assistant",
                        fontWeight: 800,
                        textTransform: "none",
                        color: "#24658E",
                        backgroundColor: "#EEF7FF",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#DDEFFF", boxShadow: "none" },
                      }}
                    >
                      הצג בעל מקצוע
                    </Button>
                  </NavLink>
                )}
                <Button
                  variant="contained"
                  sx={{
                    minWidth: 110,
                    px: 3,
                    py: 1.05,
                    borderRadius: "12px",
                    fontFamily: "Assistant",
                    fontWeight: 800,
                    textTransform: "none",
                    color: "#6A7785",
                    backgroundColor: "#F2F5F8",
                    boxShadow: "none",
                    "&:hover": { backgroundColor: "#E8EDF2", boxShadow: "none" },
                  }}
                  onClick={(e) => {
                    console.log("Kya chutiyap he");
                    setDoubleCheck(true);
                  }}
                >
                  לא מאשר
                </Button>
              </FlexBox>
            </Box>
          )}
          {!doubleCheck && stage === "customer-safety" && (
            <Box sx={{ ...style, textAlign: "right" }} dir="rtl">
              <Typography sx={{ mb: 1.1, fontFamily: "Assistant", fontWeight: 900, color: "#173B5C", fontSize: { xs: "1.2rem", sm: "1.35rem" } }}>
                רגע לפני שמתקדמים
              </Typography>
              <Box component="ul" sx={{ m: 0, pr: 2.4, pl: 0, color: "#334E63", lineHeight: 1.75, fontFamily: "Assistant", fontSize: { xs: "0.92rem", sm: "0.98rem" } }}>
                <li>ודאו את זהותו ופרטי ההתקשרות של בעל המקצוע לפני תחילת העבודה או העברת תשלום.</li>
                <li>בקשו הצעת מחיר כתובה הכוללת את היקף העבודה, המחיר ותנאי התשלום.</li>
                <li>לפני העברת מקדמה, ודאו מה מטרתה וששם מקבל התשלום תואם לפרטים שמסר בעל המקצוע.</li>
                <li>שמרו תכתובות ואסמכתאות ואל תעבירו כסף בעקבות לחץ או דרישה לא מוסברת.</li>
              </Box>
              <Alert severity="warning" sx={{ mt: 1.7, mb: 2, fontFamily: "Assistant", textAlign: "right", lineHeight: 1.55 }}>
                בידאיט מחברת בין הצדדים ואינה מאמתת את זהות בעל המקצוע, מקצועיותו או יכולתו לבצע את העבודה. בידאיט אינה צד לעסקה ואינה אחראית לתשלום, לביצוע העבודה או להתנהלות הצדדים.
              </Alert>
              <Button fullWidth variant="contained" onClick={updateBidAccept} sx={{ minHeight: 46, borderRadius: "12px", fontFamily: "Assistant", fontWeight: 900, textTransform: "none", background: "linear-gradient(135deg, #238BEB 0%, #3EA7FF 100%)" }}>
                קראתי והבנתי - אישור העסקה
              </Button>
              <Button fullWidth onClick={() => setStage("confirm")} sx={{ mt: 0.6, fontFamily: "Assistant", fontWeight: 700, textTransform: "none" }}>
                חזרה
              </Button>
            </Box>
          )}
          {!doubleCheck && stage === "professional-declaration" && (
            <Box sx={{ ...style, textAlign: "right", maxWidth: 540 }} dir="rtl">
              <Typography sx={{ mb: 0.7, fontFamily: "Assistant", fontWeight: 900, color: "#173B5C", fontSize: { xs: "1.15rem", sm: "1.3rem" } }}>
                הצהרת התנהלות לפני אישור העסקה
              </Typography>
              <Typography sx={{ mb: 1.5, color: "#607789", fontFamily: "Assistant", lineHeight: 1.5, fontSize: "0.93rem" }}>
                ההצהרה תישמר ותוצג ללקוח כחלק מתיעוד העסקה.
              </Typography>
              <TextField select fullWidth label="האם תבקש מקדמה?" value={advanceIntent} onChange={(e) => setAdvanceIntent(e.target.value)} sx={{ mb: 1.5, direction: "rtl" }}>
                <MenuItem value="no">לא</MenuItem>
                <MenuItem value="possible">ייתכן</MenuItem>
                <MenuItem value="yes">כן</MenuItem>
              </TextField>
              <Box component="ul" sx={{ m: 0, pr: 2.3, pl: 0, color: "#334E63", lineHeight: 1.68, fontFamily: "Assistant", fontSize: "0.9rem" }}>
                <li>אבהיר ללקוח מי יבצע את העבודה ומה סוכם.</li>
                <li>אם אבקש מקדמה, אציין מראש את הסכום ומטרת התשלום.</li>
                <li>אתאם מראש כל שינוי במחיר או בהיקף העבודה.</li>
                <li>אמסור מסמך תשלום מתאים עבור כל תשלום שאקבל.</li>
                <li>ידוע לי שמידע מטעה או חשד להונאה עלולים להביא לחסימת החשבון ולמסירת מידע לרשות מוסמכת בהתאם לדין.</li>
              </Box>
              <Typography sx={{ mt: 1.3, color: "#607789", fontFamily: "Assistant", fontSize: "0.84rem", lineHeight: 1.5 }}>
                אישור ההצהרה, פרטי החשבון, פרטי העסקה ומועד הפעולה נשמרים במערכות בידאיט.
              </Typography>
              <FormControlLabel
                sx={{ alignItems: "flex-start", m: 0, mt: 0.8, mb: 1 }}
                control={<Checkbox checked={declarationAccepted} onChange={(e) => setDeclarationAccepted(e.target.checked)} />}
                label={<Typography sx={{ fontFamily: "Assistant", fontWeight: 700, fontSize: "0.9rem", pt: 0.7 }}>קראתי ואני מאשר את הצהרת ההתנהלות</Typography>}
              />
              {formError && <Alert severity="error" sx={{ mb: 1.2, fontFamily: "Assistant" }}>{formError}</Alert>}
              <Button fullWidth variant="contained" onClick={submitProfessionalDeclaration} sx={{ minHeight: 46, borderRadius: "12px", fontFamily: "Assistant", fontWeight: 900, textTransform: "none", background: "linear-gradient(135deg, #FA9B28 0%, #FFB64C 100%)" }}>
                אישור ההצהרה והעסקה
              </Button>
              <Button fullWidth onClick={() => setStage("confirm")} sx={{ mt: 0.6, fontFamily: "Assistant", fontWeight: 700, textTransform: "none" }}>
                חזרה
              </Button>
            </Box>
          )}
          {doubleCheck && (
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                sx={{
                  mb: 2.5,
                  fontFamily: "Assistant",
                  fontWeight: 800,
                  color: "#7A3E37",
                  lineHeight: 1.55,
                  fontSize: { xs: "1.05rem", sm: "1.2rem" },
                }}
                variant="h6"
                component="h2"
              >
                האם אתה בטוח שברצונך לבטל את ההצעה?
              </Typography>
              <FlexBox
                sx={{
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "stretch",
                  justifyContent: "center",
                  gap: 1.2,
                }}
              >
                <Button
                  variant="contained"
                  onClick={
                    mes === "Offer Accept"
                      ? handleOfferReject
                      : handleBidderReject
                  }
                  sx={{
                    minWidth: 130,
                    px: 3,
                    py: 1.05,
                    borderRadius: "12px",
                    fontFamily: "Assistant",
                    fontWeight: 800,
                    textTransform: "none",
                    backgroundColor: "#D95045",
                    boxShadow: "0 8px 18px rgba(217,80,69,.18)",
                    "&:hover": { backgroundColor: "#C4453B" },
                  }}
                >
                  כן אני בטוח
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    minWidth: 110,
                    px: 3,
                    py: 1.05,
                    borderRadius: "12px",
                    fontFamily: "Assistant",
                    fontWeight: 800,
                    textTransform: "none",
                    color: "#31546F",
                    backgroundColor: "#EEF3F7",
                    boxShadow: "none",
                    "&:hover": { backgroundColor: "#E2EAF0", boxShadow: "none" },
                  }}
                  onClick={(e) => setDoubleCheck(false)}
                >
                  חזור
                </Button>
              </FlexBox>
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
}
